"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomQuestionMessage;
(function (CustomQuestionMessage) {
    CustomQuestionMessage["SET_QUESTION_SIZE_MSG"] = "\u0192_sqz";
    CustomQuestionMessage["REQUEST_ANSWER_VALUE_MSG"] = "\u0192_rav";
    CustomQuestionMessage["SET_ANSWER_VALUE_MSG"] = "\u0192_sav";
    CustomQuestionMessage["REQUEST_SEMANTIC_ANSWER_VALUE_MSG"] = "\u0192_rsv";
    CustomQuestionMessage["SET_SEMANTIC_ANSWER_VALUE_MSG"] = "\u0192_ssv";
    CustomQuestionMessage["REQUEST_ANSWERS_MSG"] = "\u0192_ra";
    CustomQuestionMessage["SET_ANSWERS_MSG"] = "\u0192_sa";
    CustomQuestionMessage["REQUEST_RESPONDER_UUID_MSG"] = "\u0192_rru";
    CustomQuestionMessage["SET_RESPONDER_UUID_MSG"] = "\u0192_sru";
    CustomQuestionMessage["CLEAR_ANSWER_VALUE_MSG"] = "\u0192_cav";
    CustomQuestionMessage["SET_DISABLE_BACK_NAVIGATION_MSG"] = "\u0192_sdbn";
})(CustomQuestionMessage || (CustomQuestionMessage = {}));
exports.default = CustomQuestionMessage;
